module.exports = __webpack_public_path__ + "static/overhead-cc950be5ef78d19ea287065c71da7447.png";